import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Modal from "./Modal";
import { API_DOMAIN_URL } from "../Common";

export function GroupAddMode({ orgUserId, updateOwnedGroups, setDisplayMode }) {
  // Validationスキーマの定義
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("グループ名を入力してください").max(100, "グループ名は100文字以内で入力してください"),
    Note: Yup.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    if (data.Name == undefined) {
      console.log("Invalid Input Value");
      return;
    }

    let addingGroup = {};
    addingGroup.Name = data.Name;
    addingGroup.Note = data.Note;
    addingGroup.AvatarId = "groupSample";

    addGroup(addingGroup);
  };

  const addGroup = (addingGroup) => {
    if (!addingGroup) {
      return;
    }

    // update db
    const bodyString = JSON.stringify(addingGroup);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/CreateGroup?code=${code}&UserId=${orgUserId}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          successModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const successModalOpen = () => {
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
    setDisplayMode(2); // 非活性化
    updateOwnedGroups(); // 組織内ユーザーを再取得
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const errorModalOpen = () => {
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  return (
    <>
      <Typography component="h1" variant="h5" sx={{ mt: 3 }}>
        グループ新規追加
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ mt: 5, p: 3, border: "1px solid grey" }}
      >
        <Typography variant="h6" align="center">
          グループ情報
        </Typography>
        <Grid md={{ flexGrow: 1 }} container spacing="2">
          <Grid item md={12}>
            <Grid container justifyContent="center" spacing={1}>
              <Grid item md={12}>
                <TextField
                  name="Name"
                  fullWidth
                  required
                  size="small"
                  id="Name"
                  label="グループ名"
                  {...register("Name")}
                  error={errors.Name ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Name?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              sx={{ mt: "1px" }}
              spacing={1}
            >
              <Grid item md={12}>
                <TextField
                  name="Note"
                  required
                  fullWidth
                  size="small"
                  id="Note"
                  label="備考"
                  {...register("Note")}
                  error={errors.Note ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Note?.message}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={8} container justifyContent="right">
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2, width: 100 }}
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            追加
          </Button>
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2, width: 120 }}
            onClick={() => setDisplayMode(2)}
          >
            キャンセル
          </Button>
        </Grid>
      </Grid>
      <Modal
        title={"登録失敗"}
        message={"グループの登録に失敗しました"}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={"登録成功"}
        message={"グループの登録が完了しました"}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </>
  );
}

GroupAddMode.propTypes = {
  orgUserId: PropTypes.number,
  setDisplayMode: PropTypes.number,
  updateOwnedGroups: PropTypes.any,
};
